import { UserLicenseKeyTable } from "../../component/UserLicenseKeyTable";

export default function UserLicenseKeyPage() {
  return <UserLicenseKeyTable />;
}